import type { UserIdentity } from 'react-admin';

/**
 * The subset of Cognito ID-token claims we read. `custom:role` and
 * `custom:region` are the custom attributes defined on the pool (step 0.2);
 * region enforcement comes later but the claims must be readable now.
 */
export interface IdTokenPayload {
  readonly sub: string;
  readonly email?: string;
  readonly 'custom:role'?: string;
  readonly 'custom:region'?: string;
  readonly [claim: string]: unknown;
}

/** Identity exposed to React Admin, with the user's region attached. */
export interface AdminIdentity extends UserIdentity {
  readonly email: string;
  readonly region: string | null;
}

/** The role used by getPermissions (route guards arrive in 0.3). */
export function parseRole(payload: IdTokenPayload): string | null {
  return payload['custom:role'] ?? null;
}

/** Identity (id + email + region) used by getIdentity. */
export function parseIdentity(payload: IdTokenPayload): AdminIdentity {
  const email = payload.email ?? '';
  return {
    id: payload.sub,
    fullName: email,
    email,
    region: payload['custom:region'] ?? null,
  };
}
